<div class="sd-form-field-new">
  <div *ngIf="label" class="field-label">
    {{ label }}
    <span class="field-label-asterisk" *ngIf="required">*</span>
  </div>
  <div class="position-relative">
    <ng-content></ng-content>
    <cx-icon *ngIf="required && control.value && control.valid" class="check-icon" [type]="iconType.CHECK"></cx-icon>
  </div>

  <div *ngIf="hint" class="field-hint">{{ hint }}</div>
  <cx-form-errors
    *ngIf="control"
    [control]="control"
    [translationParams]="control.errors | sdErrorParams"
  ></cx-form-errors>
</div>
